var map = {
	"./search-results.de-CH.json": 936,
	"./search-results.de-DE.json": 937,
	"./search-results.en-CA.json": 938,
	"./search-results.en-GB.json": 939,
	"./search-results.en-IN.json": 940,
	"./search-results.en-ME.json": 941,
	"./search-results.en-US.json": 942,
	"./search-results.es-EM.json": 943,
	"./search-results.es-ES.json": 944,
	"./search-results.fr-BE.json": 945,
	"./search-results.fr-CA.json": 946,
	"./search-results.fr-CH.json": 947,
	"./search-results.nl-BE.json": 948,
	"./search-results.nl-NL.json": 949,
	"./search-results.pl-PL.json": 950,
	"./search-results.pt-BR.json": 951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 935;